import z from "zod";

export const CreateAttachmentBodySchema = z.object({
  name: z.string(),
  mimeType: z.string(),
  sizeBytes: z.number().int().positive(),
});

// The PUT to uploadUrl has to carry the requested mime type as its Content-Type and every upload
// header exactly as given: the URL is signed for them, so the bucket refuses a PUT missing one.
export const CreateAttachmentResponseSchema = z.object({
  artifactId: z.string(),
  uploadUrl: z.string(),
  uploadHeaders: z
    .record(z.string(), z.string())
    .nullish()
    .transform((v) => v ?? {}),
});

export const AttachmentIdParamsSchema = z.object({
  artifactId: z.string(),
});

export const ConfirmAttachmentUploadResponseSchema = z.object({
  // A PDF too big to send the model natively: the server adds it to the library whatever the
  // prompt asks, and the model reads it through search once it's indexed.
  ingestOnly: z.boolean().default(false),
});

export const AddAttachmentToLibraryBodySchema = z.object({
  chatId: z.string(),
});

export const AddAttachmentToLibraryResponseSchema = z.object({
  assetId: z.string(),
});

export const ArtifactSignedUrlsBodySchema = z.object({
  artifactIds: z.array(z.string()),
});

// An artifact the caller can't read is left out of the list rather than reported.
export const ArtifactSignedUrlsResponseSchema = z.object({
  urls: z
    .array(
      z.object({
        artifactId: z.string(),
        url: z.string(),
        expiresAt: z.string(),
        // Set on a user attachment once it has been added to the Library.
        assetId: z.string().optional(),
        error: z.string().optional(),
      })
    )
    .nullable()
    .transform((v) => v ?? []),
});
